// noinspection JSUnusedGlobalSymbols
export enum TypewriterDelay {
    ExtraSlow = 4000,
    Slow = 2000,
    Medium = 1000,
    Fast = 500,
    ExtraFast = 250,
    None = 0,
}

// noinspection JSUnusedGlobalSymbols
export enum TypewriterSpeed {
    ExtraSlow = 40,
    Slow = 20,
    Medium = 10,
    Fast = 5,
    ExtraFast = 2.5,
}
